// extracted by mini-css-extract-plugin
export default {"main":"CustomForm_main__Z9zkd","inputsection":"CustomForm_inputsection__j24jU","buttonsection":"CustomForm_buttonsection__iZf7f"};